import React from 'react';

import PropTypes from 'prop-types';

const ContentHeader = (props) => {
  const {
    header, subtitle,
  } = props;

  return (
    <div className="contentHeader" id="contentHeader">
      {/* <BreadCrumbs /> */}
      <h3>{header}</h3>
      {props.children}
      <hr />
      <h6>{subtitle}</h6>
    </div>
  );
};

export default ContentHeader;

ContentHeader.propTypes = {
  header: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node,
};

ContentHeader.defaultProps = {
  header: 'CONTENT HEADER',
  subtitle: '',
  children: null,
};
